'use strict';

let data = {};

/**
 * Container save all data in a object, you can retrieve them easily
 *
 * @module core/container
 * @author Julien Trollé <julien.trolle@lp-digital.fr>
 * @author Florian Kroockmann <florian.kroockmann@lp-digital.fr>
 */
module.exports = {
  data,
  /**
   * Get data with key
   *
   * @example container.get('my-data') // {country: 'France'}
   * @param  {string} key
   * @returns {Mixed} data
   */
  get: function(key) {
      return data[key];
  },

  /**
   * Set data with key, value
   *
   * @example container.set('my-data', {country: 'France'})
   * @param {string} key
   * @param {function(*): boolean} value
   */
  set: function(key, value) {
      data[key] = value;
  },

  /**
   * Unset data from container
   *
   * @example container.unset('my-data');
   * @param {string} key
   */
  unset: function(key) {
      delete data[key];
  },

  /**
   * Clear container
   * @example container.clear();
   */
  clear: function() {
      data = {};
  },
};
